import { useCallback, useEffect, useRef } from 'react';
import { useColorModeValue } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import i18n from 'i18next';

import GET_STORY from '../../graphql/queries/getStory';
import { canUseDom, getImg } from '../../utils';
// import { injectScript } from '../../utils/injectScript';
//
// let script1: HTMLScriptElement;
// let script2: HTMLScriptElement;

export default function useStory() {
  const storyRef = useRef();
  const { pathname } = useLocation();
  const hash = pathname.split('-').pop();
  const figureOpacity = useColorModeValue('1', '0.6');
  const borderColor = useColorModeValue('#cccccc', '#ffffff');
  const { loading, error, data } = useQuery(GET_STORY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      language: i18n.language,
      hash,
    },
  });

  const transformStory = useCallback((data: any) => {
    const story = data?.story;
    const hash = story?.hash;
    const createdNews = story?.createdNews;
    const title = createdNews?.info?.title;
    const description = createdNews?.info?.description;
    const keywords = createdNews?.info?.keywords;
    const intro = createdNews?.info?.intro;
    const lead = createdNews?.info?.lead;
    const content = createdNews?.info?.content;
    const url = `/${i18n.language}/stories/${createdNews?.info?.slug}-${hash}`;
    const sourceName = createdNews?.source?.name || 'news.24.md';
    const image = story?.images?.[0];

    return {
      hash,
      url,
      title,
      description,
      keywords,
      intro,
      lead,
      content,
      hasContentImage: /img.*/g.test(content),
      image: image ? getImg(image?.name, image, 'original') : null,
      views: story?.views,
      createdAt: story?.created_at,
      source: sourceName || 'news.24.md',
      sharer: {
        title,
        image: '',
        url: process.env.REACT_APP_CLIENT_HOST + url,
        subject: `${title} | news.24.md`,
        body: '',
      },
    };
  }, []);

  const handleIframes = useCallback(() => {
    const matches = document.querySelectorAll('article iframe');

    for (let i = 0; i < matches?.length; i++) {
      const iframe = matches?.[i].getBoundingClientRect();
      const iframeSrc = matches?.[i].getAttribute('src') || '';

      // set scrolling no attribute to avoid flickering
      matches?.[i].setAttribute('scrolling', `no`);

      // facebook limit resizing, preventing...
      if (!iframeSrc.includes('facebook')) {
        matches?.[i].setAttribute(
          'style',
          `
            width: calc(100% + 1.5rem);
            min-height: ${Math.ceil(((iframe?.width / 100) * 56) / 16)}rem;
          `
        );
      }
    }
  }, []);

  useEffect(() => {
    if (canUseDom) {
      // script1 = injectScript(`https://jsc.mgid.com/n/e/news.24.md.1307866.js`);
      // script2 = injectScript(`https://jsc.mgid.com/n/e/news.24.md.1307868.js`);
      setTimeout(handleIframes, 300);
    }

    // return () => {
    //   if (canUseDom) {
    //     document.body.removeChild(script1);
    //     document.body.removeChild(script2);
    //   }
    // };
  }, [data, handleIframes]);

  return {
    pathname,
    borderColor,
    figureOpacity,
    story: data && transformStory(data),
    storyRef,
    loading,
    error,
  };
}
